"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonGroup, Button as MantineButton, createPolymorphicComponent, factory, useProps, } from "@mantine/core";
// Global button style, must come first
import "@mantine/core/styles/UnstyledButton.layer.css";
// Other styles
import "@mantine/core/styles/Button.layer.css";
import "@mantine/core/styles/Loader.layer.css";
import * as styles from "./Button.module.css";
const Button = createPolymorphicComponent(factory((props, 
// biome-ignore lint/suspicious/noExplicitAny: Polymorphic component
ref) => {
    const modifiedProps = useProps("Button", {
        classNames: styles,
        size: "md",
    }, props);
    return _jsx(MantineButton, { ...modifiedProps, ref: ref });
}));
Button.displayName = "Button";
ButtonGroup.displayName = "ButtonGroup";
Button.Group = ButtonGroup;
export { Button };
//# sourceMappingURL=Button.js.map